import styled from 'styled-components';
import { Button } from '@insurancemenu/imenu-components-lib';
import { colors } from '@insurancemenu/imenu-components-lib/dist/utils';

export const ActionBarStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: center;
  gap: 6rem 8%;
  margin: 0 auto 10rem;
`;

export const FiltersWrapperStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 3rem;
`;

export const ButtonsWrapperStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 3rem;
`;

export const BrowseButtonStyled = styled(Button)`
  background-color: ${colors.neutral.white};
  min-width: 22rem;
`;

export const HelpButtonStyled = styled(Button)`
  min-width: 22rem;
`;
